import React from 'react';
import FabricCare from './FabricCare';
import TmntHtml from '../../../tools/TmntHtml';
import BuyGridAccordion from '../../../components/BuyGridAccordion/BuyGridAccordion';
import ESpotContent from '../../../components/ESpotContent/ESpotContent';

export default function DetailsAccordion({
  activeProduct, activeAccordion, onClick, tmntData, siteRegion, eSpotContent, isEyewearProduct,
}) {
  const accordionIdentifier = 'product-details__accordion';
  const anfCaresTMNT = tmntData?.environmentalQualities?.value;
  const isEU = siteRegion === 'EU';

  return (
    <BuyGridAccordion
      id="details-accordion"
      headerText={tmntData?.accordionTitle?.value}
      onClick={onClick(accordionIdentifier)}
      expanded={activeAccordion === accordionIdentifier}
    >
      <ESpotContent eSpotData={eSpotContent?.pdp_productdetails} />
      <div className="details-accordion-mfe__info">
        <h2
          className="h2 details-accordion-mfe__header"
          data-property={tmntData?.accordionHeader?.key}
        >
          {tmntData?.accordionHeader?.value}
        </h2>
        <h3 className="h3 details-accordion-mfe__product-title">
          {activeProduct.productName}
        </h3>
        <div className="details-accordion-mfe__description">
          <TmntHtml value={activeProduct.longDescription} />
        </div>
      </div>
      <FabricCare
        fabricDetails={activeProduct.fabricDetails}
        careDetailsList={activeProduct.careDetailsList}
        isEyewearProduct={isEyewearProduct}
      />
      <hr />
      <p
        className="details-accordion-mfe__store-item-number text-small"
        data-property={tmntData?.storeItemNumber?.key}
      >
        <span className="details-accordion-mfe__store-item-title">
          {tmntData?.storeItemNumber?.value}
          {' '}
        </span>
        <span>
          {activeProduct.storeItemNumber}
        </span>
      </p>

      <p
        className="details-accordion-mfe__web-item-number text-small"
        data-property={tmntData?.webItemNumber?.key}
      >
        <span className="details-accordion-mfe__web-item-title">
          {tmntData?.webItemNumber?.value}
          {' '}
        </span>
        <span className="details-accordion-mfe__web-item-number">
          {activeProduct.webItemNumber}
        </span>
      </p>

      {isEU ? (
        <div className="environmental-qualities-statement">
          <hr />
          <p className="anf-cares text-small">
            <TmntHtml value={anfCaresTMNT} />
          </p>
        </div>
      )
        : ''}
    </BuyGridAccordion>
  );
}
